export default __webpack_public_path__ + "static/media/pic11.9751d7cd.jpg";